import axios from '@/utils/request'
import base from './base'
import qs from 'qs'

export function tradingPositions(data) { return axios.post(`${base.url}/business/trading/positions`, qs.stringify(data)) }
export function tradingGroupOptions(data) { return axios.post(`${base.url}/business/trading/groupOptions`, qs.stringify(data)) }
export function tradingOrders(data) { return axios.post(`${base.url}/business/trading/orders`, qs.stringify(data)) }
export function tradingDeals(data) { return axios.post(`${base.url}/business/trading/deals`, qs.stringify(data)) }
export function tradingExportPositions(data) { return axios.post(`${base.url}/business/trading/exportPositions`, qs.stringify(data), { responseType: 'blob' }) }
export function tradingExportOrders(data) { return axios.post(`${base.url}/business/trading/exportOrders`, qs.stringify(data), { responseType: 'blob' }) }
export function tradingExportDeals(data) { return axios.post(`${base.url}/business/trading/exportDeals`, qs.stringify(data), { responseType: 'blob' }) }
